module.exports = {"id":"225121","name":"Castro","rating":"71","photo":"./data/images/photos/1/225121.png","club":{"name":"Sporting Gijón","logo":"./data/images/clubs/SportingGijon.png"},"positions":["BU","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Castro0.json
// module id = 739
// module chunks = 0